module.exports = __webpack_public_path__ + "img/99.98e4364d.jpg";